// Notification
export const NOTIFICATION_ERROR_CSS_CLASS = 'error';
